import { createSlice } from '@reduxjs/toolkit'
import { actions as dashboardActionsF } from './dashboard'
import { actions as dashboardTargetsActionsF } from './dashboardTargets'
import { actions as localActionsF } from './local'

const reducer = createSlice({
  name: 'app',
  initialState: {
    loaded: false,
    currentUser: {},
  },
  reducers: {
    set: (s, a) => a.payload,
    upsert: (s, a) => ({ ...s, ...a.payload })
  },
}).reducer

const actions = (dis, store, restClient) => {
  const localActions = localActionsF(dis, store, restClient)
  const dashboardActions = dashboardActionsF(dis, store, restClient)
  const dashboardTargetsActions = dashboardTargetsActionsF(dis, store, restClient)

  function load(dashboardId) {
    dis({ type: 'app/upsert', payload: { dashboardId } })

    restClient.get(`/api/user/dashboards/${dashboardId}`)
      .then(({ data }) => {
        dis({ type: 'app/upsert', payload: { loaded: true } })
        dashboardActions.set(data)
      })
      .catch((err) => {
        console.error('Error loading dashboard:', err)
        dis({ type: 'app/upsert', payload: { loaded: false } })
        dis({ type: 'local/upsert', payload: { alert: {
          severity: 'error',
          message: "Something went wrong and the dashboard couldn't be loaded."
        } } })
      })

    return reloadTargets()
  }

  function loadMe() {
    restClient.get('/api/users/me')
    .then(({ data }) => {
      dis({ type: 'app/upsert', payload: { currentUser: data } })
    })
  }

  function reloadTargetsInternal() {
    const state = store.getState()
    const dashboardId = state.app.dashboardId
    const filters = state.local.filters
    const page = Math.max(1, state.local.currentPage)
    if (!dashboardId) return

    dis({ type: 'local/upsert', payload: { dataLoading: true, isDirty: false, submittedFilters: filters } })

    return restClient.get(`/api/user/dashboards/${dashboardId}/dashboard_targets`, {
      params: { page, filters }
    })
      .then(({ data }) => {
        localActions.upsert(data.pagination)
        dashboardTargetsActions.setAll(data.dashboardTargets)
      })
      .catch((err) => {
        console.error('Error reloading targets:', err)
        dis({ type: 'app/upsert', payload: { loaded: false } })
        dis({ type: 'local/upsert', payload: { alert: {
          severity: 'error',
          message: "Something went wrong and the dashboard couldn't be reloaded."
        } } })
      })
      .finally(() => {
        dis({ type: 'local/upsert', payload: { dataLoading: false } })
      })
  }

  const reloadTargets = _.debounce(reloadTargetsInternal, 100)

  const pendingUpdates = {}

  function answerQuestion({ dashboardTargetId, questionId, answer }) {
    const updateIndex = pendingUpdates[dashboardTargetId] || 0

    return  restClient.post(`/api/user/dashboard_targets/${dashboardTargetId}/answer_question`, { questionId, answer })
      .then(({ data }) => {
        if (updateIndex === pendingUpdates[dashboardTargetId]) { // only apply the update if it's the latest one.
          dashboardTargetsActions.upsert(data.id, data)
        }
      })
      .catch(() => {
        dis({ type: 'local/upsert', payload: { alert: {
          severity: 'error',
          message: "Something went wrong and the answer couldn't be saved."
        } } })
      })
  }

  function setPendingUpdate(dashboardTargetId) {
    pendingUpdates[dashboardTargetId] ||= 0
    pendingUpdates[dashboardTargetId] += 1
  }

  return {
    load,
    loadMe,
    reloadTargets,
    answerQuestion,
    setPendingUpdate
  }
}

export { reducer, actions }
export default { reducer, actions }
